import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';

Vue.prototype.$http = axios;
Vue.config.productionTip = false
new Vue({
  router,
  store,
  data: {
    user_token:'',
    site_id:'',
  },
  render: h => h(App)
}).$mount('#app')
